import { baseApi } from './baseApi';

export const uploadApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPresignedUrl: builder.mutation<
      { url: string; fields: Record<string, string>; fileKey: string },
      { fileName: string; fileType: string; qrSessionToken: string; customerLat?: number; customerLng?: number }
    >({
      query: (body) => ({
        url: '/upload/presigned-url',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetPresignedUrlMutation } = uploadApi;
